import { usePageStore, type LayoutKey } from "@astrox/ui-vue/store";
import { createRouter, createWebHistory } from "vue-router";
import { authRoute } from "./features/auth/presentation/routes/authRoute";
import { useAddAccountStore } from "./features/auth/presentation/stores/addAccountStore";
import { useLoginStore } from "./features/auth/presentation/stores/loginStore";
import { useMfaMethodStore } from "./features/auth/presentation/stores/mfaMethodStore";
import { useOtpVerifyStore } from "./features/auth/presentation/stores/otpVerifyStore";
import { menuUtil } from "./utils/menuUtil";

export function setupRouter() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_URL || "/"),
    routes: [...authRoute],
  });

  let isAppInitialized = false;

  router.beforeEach(async (to) => {
    const pageStore = usePageStore();
    const loginStore = useLoginStore();
    const addAccountStore = useAddAccountStore();
    const mfaMethodStore = useMfaMethodStore();
    const otpVerifyStore = useOtpVerifyStore();

    const breadcrumbs = typeof to.meta.breadcrumbs === "function" ? to.meta.breadcrumbs(to) : to.meta.breadcrumbs;

    pageStore.updatePageConfig({
      title: to.meta.title as string | undefined,
      activeMenu: to.meta.menu as any,
      menuOptions: menuUtil((t: any) => t),
      layout: to.meta.layout as LayoutKey | "none" | undefined,
      breadcrumbs: breadcrumbs ?? [],
      route: to,
    });

    const clientId = to.query.clientId as string;
    const redirectUri = to.query.redirectUri as string;

    // Validasi client berdasarkan tujuan route
    if (to.name === "auth.login") {
      try {
        await loginStore.validateClient(clientId, redirectUri);
      } catch (error) {}
    } else if (to.name === "auth.add-account") {
      try {
        await addAccountStore.validateClient(clientId, redirectUri);
      } catch (error) {}
    } else if (to.name === "auth.mfa-method") {
      try {
        await mfaMethodStore.validateClient(clientId, redirectUri);
      } catch (error) {}
    } else if (to.name === "auth.otp-verify") {
      try {
        await otpVerifyStore.validateClient(clientId, redirectUri);
      } catch (error) {}
    }

    if (!isAppInitialized) {
      if (to.name === "auth.login" && loginStore.isClientValid) {
        pageStore.initAppMetadata({
          appName: loginStore.clientName,
          appDescription: loginStore.clientDescription,
        });
      } else if (to.name === "auth.add-account" && addAccountStore.isClientValid) {
        pageStore.initAppMetadata({
          appName: addAccountStore.clientName,
          appDescription: addAccountStore.clientDescription,
        });
      } else if (to.name === "auth.mfa-method" && mfaMethodStore.isClientValid) {
        pageStore.initAppMetadata({
          appName: mfaMethodStore.clientName,
          appDescription: mfaMethodStore.clientDescription,
        });
      } else if (to.name === "auth.otp-verify" && otpVerifyStore.isClientValid) {
        pageStore.initAppMetadata({
          appName: otpVerifyStore.clientName,
          appDescription: otpVerifyStore.clientDescription,
        });
      } else {
        pageStore.initAppMetadata({
          appName: import.meta.env.VITE_APP_NAME ?? "My App",
          appLogo: `${import.meta.env.VITE_BASE_URL || ""}/astraworld-icon.png`,
          appDescription: import.meta.env.VITE_APP_DESCRIPTION ?? "",
        });
      }
      isAppInitialized = true;
    }

    return true;
  });

  return router;
}
